import SiteController from "./controllers/SiteController";

export default class App {
  constructor(options) {
    this.options = options;

    this.pageController = {};
    this.siteController = {};
  }

  start() {
    $("document").ready($.proxy(this.handleAppReady, this));
  }

  handleAppReady() {
    console.log("APP READY!");

    this.siteController = new SiteController(this.options);

    if (
      typeof this.options.pageController !== "undefined" &&
      this.options.pageController !== ""
    ) {
      require.ensure([], (require) => {
        const PageController =
          require(`./controllers/pages/${this.options.pageController}`).default;
        this.pageController = new PageController(this.options);
      });
    } else {
      console.log("PAGE CONTROLLER NOT LOADED");
    }
  }
}



// WEBPACK FOOTER //
// ./js/app.js